import {getUser, isRiaUser} from '@simpleinvest/front-end-auth';
import windowHelper from '@client/util/windowHelper';
import {Route, NavigationGuardNext} from 'vue-router';
import {ClientWindow} from '@client/custom-window';
import {restrictAccessToLegacyApp} from '@client/remote-config';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const restrictAccessToLegacyAppFlag = async () => {
  const restrictAccess = await restrictAccessToLegacyApp();

  return restrictAccess;
};

declare let window: ClientWindow;

const redirectRiaUsersToAdvisor = async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
  if ((await restrictAccessToLegacyAppFlag()) && _to.path !== '/advisorlogin' && _to.path !== '/forgot-password') {
    window.location.href =
      process.env.VUE_APP_ENV === 'prod'
        ? 'https://secure05.principal.com/participant/member/options-smartira'
        : 'https://secure05.pilot.principal.com/participant/member/options-smartira';
  }

  try {
    await getUser();

    const isAdvisor = await isRiaUser();

    if (isAdvisor) {
      windowHelper.location.assign(`${window.BASE_URL}/advisor`);
    } else {
      // eslint-disable-next-line callback-return
      next();
    }
  } catch {
    // Auth is handled elsewhere, so calling next()
    // eslint-disable-next-line callback-return
    next();
  }
};

export default redirectRiaUsersToAdvisor;
